// To use the theme on the interface 

// const colors = useAppSelector(state => state.theme.colors);

// color: colors?.myColor            (don't forget the '?'). 


const lightTheme = { 

    // Theme

    theme: 'light', 

    // Backgrounds 

    main: '#3498DB',
    mainHover: '#2980B9',

    interface: '#F5F7FA', 
    container: '#FFFFFF',
    legend: '#DDE1E6',
    text: '#2C3E50',
    highlightedText: '#2C3E50', 
    searchBar: '#DDE1E6', 
    blueButton: '#2980B9', 
    disabledIcon: '#95a5a6', 
    disabledRelatedPatient: 'rgba(189, 195, 199, 0.5)',
    newFolderIcon: '#3498DB',
    uploadFileIcon: '#2ECC71',
    relatedPatientIcon: '#9B59B6',
    refreshIcon: '#3498DB',
    changeViewIcon: '#9B59B6',
    fileExplorerSearchBar: '#DDE1E6', 
    selectedSibebarSection: '#3498DB',
    correctFileIcon: '#2ECC71', 
    renameFileIcon: '#3498DB',
    moveToIcon: '#3498DB',
    patientInfoIcon: '#9B59B6', 
    deleteIcon: '#E74C3C', 
    viewFileIcon: '#F39C12', 
    actionBackground: '#FFFFFF', 
    removePinIcon: '#E74C3C',
    pinFolderIcon: '#F39C12', 
    searchIcon: '#2C3E50',

    sectionHover: '#EBF0F5', 
    patientSectionHover: '#EBF0F5',
    selectedSectionHover: '#DDE1E6', 
    unselectedSection: '#FFFFFF', 

    // File Explorer folder data, 

    hiddenBox: 'rgba(44, 62, 80, 0.7)',
    hiddenRow: 'rgba(52, 152, 219, 0.1)',
    sharedFolder: '#2ECC71',
    folderDataRowBorderColor: 'rgba(221, 225, 230, 0.6)', 

    searchQueryFile: '#3498DB',
    searchQueryFolder: '#3498DB', 

    // Correct File. 

    reviewIcon: '#2ECC71',
    correction: '#DDE1E6', 
    correctionHoverQuit: 'rgba(127, 140, 141, 0.2)', 

    fileViewerQuit: 'rgba(87, 101, 116, 0.5)', 

    dropdown: '#DDE1E6',
    fileExplorerDropdown: '#DDE1E6', 
    fileExplorerFooter: '#F5F7FA', 

    // File Explorer: 

    recentFolderIcon: '#F39C12',
    patientsFolderIcon: '#3498DB',
    downloadsFolderIcon: '#2ECC71',
    documentsFolderIcon: '#9B59B6', 
    pinIconColor: '#F39C12',
    legendCheckIcon: '#2ECC71', 

    consultationFolder: '#2980B9', 
    folder: '#F39C12',
    file: '#9B59B6', 

    listInfo: '#576574',

    closeButtonBackground: '#576574',
    closeButtonText: '#FFFFFF', 

    patientExitButton: '#FFFFFF',
    patientExitButtonBackground: '#E74C3C',

    deleteUploadedFile: '#E74C3C', 
    deleteUploadedFileHover: '#c0392b', 

    exitButtonColor: '#c0392b',
    exitButtonColorHover: '#E74C3C',
    exitButtonText: '#FFFFFF',
    cancelButtonText: '#576574', 
    cancelButtonColor: '#DDE1E6',  
    cancelButtonBackground: '#F5F7FA',

    updatePatientDetails: '#3498DB' ,
    confirmPatientInfoText: '#576574',

    emergencyContacts: '#F5F7FA',

    // File Explorer Footer

    driveIcon: '#F39C12',
    accountFooterIcon: '#9B59B6',

    directory: '#3498DB',

//  const colors = useAppSelector(state => state.theme.colors);

    createPatientContainer: '#2C3E50',
    createPatientDisabledIcon: '#576574',
    createPatientEnabledIcon: '#FFFFFF',
    createPatientRequired: '#E74C3C', 
    createPatientSelect: '#3498DB',
    createPatientError: '#E74C3C',
    createPatientOptionsList: '#F5F7FA',
    createPatient: '#3498DB',

    completedCategory: '#2ECC71',
    incompletedCategory: '#95a5a6',
    incompletedCategoryHover: '#F39C12', 
    erroredCategory: '#E74C3C',
    erroredCategoryHover: '#c0392b', 
    fieldErrorMessage: '#E74C3C',

    requiredFieldsWarning: '#576574',
    patientContainer: '#2C3E50',

    listHeaderBackground: '#F5F7FA',

    optionContainer: '#2C3E50', 

    directiveIcon: '#2ECC71',
    createDirective: '#3498DB', 
    directiveAlertIcon: '#F39C12', 

    noteIcon: '#2ECC71',
    createNote: '#3498DB', 
    createNoteHover: 'rgba(52, 152, 219, 0.1)',
    noteDescription: '#576574', 
    noteDropdown: '#2C3E50',
    noteDropdownHover: '#576574', 
    
    notificationsContainer: '#2C3E50',
    
    calendarBackground: 'rgba(243, 156, 18, 0.15)',
    calendarHover: 'rgba(243, 156, 18, 0.25)',
    calendarIcon: '#F39C12',

    notificationsBackground: 'rgba(46, 204, 113, 0.15)', 
    notificationsHover: 'rgba(46, 204, 113, 0.25)',
    notificationsIcon: '#2ECC71',

    accessRequestsBackground: 'rgba(155, 89, 182, 0.15)',
    accessRequestsHover: 'rgba(155, 89, 182, 0.25)', 
    accessRequestsIcons: '#9B59B6',
    accessRequestVerifiedIcon: '#2ECC71', 

    overviewRowHover: 'rgba(52, 152, 219, 0.1)',
    overviewIcon: '#3498DB',

    // Patient Info categories 

    firstName: '#3498DB',
    lastName: '#3498DB',
    gender: '#576574', 
    dateOfBirth: '#576574',
    healthCardNumber: '#576574',
    phone: '#3498DB' ,
    email: '#3498DB',
    address: '#576574',
    patientId: '#576574',
    emergencyContactName: '#3498DB',
    emergencyContactRelation: '#9B59B6',
    emergencyContactPhone: '#3498DB',

    patientSearchDropdownRow: '#FFFFFF',
    patientSearchDropdownRowHover: '#F5F7FA',

    patientFoundContainer: '#F5F7FA',
    patientFoundAvatar: '#3498DB',
    patientFoundInfo: '#2C3E50',
    patientFoundInfoSecure: '#2ECC71',
    patientSearchRow: '#FFFFFF',
    patientSearchColor: '#2C3E50',
    patientRowUnselected: '#FFFFFF',
    patientRowIcon: '#3498DB', 
    patientDataSection: '#F5F7FA',

    accessRequested: '#2ECC71',
    accessRequestedHover: '#27AE60',

    // Options 

    account: '#3498DB', 
    accountHover: 'rgba(52, 152, 219, 0.1)',

    editPatient: '#2ECC71', 
    editPatientHover: 'rgba(46, 204, 113, 0.1)', 

    filesOption: '#3498DB', 
    filesOptionHover: 'rgba(52, 152, 219, 0.1)', 

    notesOption: '#9B59B6',
    notesOptionHover: 'rgba(155, 89, 182, 0.1)', 
    
    directivesOption: '#F39C12',
    directivesOptionHover: 'rgba(243, 156, 18, 0.1)',

    logsOption: '#576574', 
    logsOptionHover: 'rgba(87, 101, 116, 0.1)', 

    settingsOption: '#576574',
    settingsOptionHover: 'rgba(87, 101, 116, 0.1)',

    settingsPinUpdate: '#F39C12',
    settingsPinUpdateHover: '#e67e22',

    // Templates 

    codeBox: '#DDE1E6',
    qrValueBackground: 'rgba(52, 152, 219, 0.1)', 
    qeValueBorder: 'rgba(52, 152, 219, 0.3)', 

    createTemplate: '#F5F7FA',
    createTemplateIcon: '#3498DB',
    templateSearch: '#DDE1E6', 
    templateBoxText: '#2C3E50',  
    templateBoxBorder: '#DDE1E6',
    templateBoxIcon: '#3498DB',
    templateBoxHover: '#EBF0F5',
    templateBoxHoverBorder: '#3498DB',
    templateHover: 'rgba(87, 101, 116, 0.1)',
    templateTextHover: '#2C3E50', 

    notification: '#2C3E50',
    notificationText: '#FFFFFF', 

    popup: 'rgba(44, 62, 80, 0.75)',

    navBar: '#FFFFFF', 

    footerText: '#576574',
    footerLinkHover: '#3498DB', 

    sidebar: '#FFFFFF', 
    sidebarItemSelectedSection: '#2980B9',
    sidebarUnselectedItem: '#576574',
    subSidebarSection: '#2C3E50',
    sidebarSelectedItemBackground: 'rgba(52, 152, 219, 0.1)',
    sidebarItemHover: 'rgba(52, 152, 219, 0.2)',

    legalText: '#576574', 
    legalBannerText: '#576574',
    legalDescription: '#576574',
    legalDescriptionBackground: '#DDE1E6',
    legalLearMore: '#3498DB',
    legalLearnMoreHover: '#2980B9',
    legalHeader: '#2C3E50', 
    legalSubTitle: '#576574',

    scanTemplateCameraIcon: '#3498DB',
    scanTemplateFromPhotosIcon: '#2ECC71',
    scanTemplateTakePicture: '#3498DB',
    scanTemplateFlipCamera: '#2ECC71',

    scanTemplateUploadBackground: '#2C3E50',
    scanTemplateUploadBorder: '#DDE1E6',
    scanTemplateSubmitButton: '#3498DB',
    scanTemplateCreated: '#2ECC71',

    settingsBackButtonHover: 'rgba(87, 101, 116, 0.2)',
    settingsAccountIcon: '#3498DB',
    settingsEmailIcon: '#2ECC71',
    settingsStatusIcon: '#9B59B6',
    settingsSoftwareVersion: '#576574',
    settingsThemeLightMode: '#FFFFFF',
    settingsThemeDarkMode: '#2C3E50',
    settingsDarkTheme: '#FFFFFF', 
    settingsLightTheme: '#2C3E50', 

    supportEmailBackground: '#FFFFFF',
    supportTicketsListHeader: '#F5F7FA',
    supportHistoryHeader: '#F5F7FA',  
    supportHistory: '#DDE1E6', 

    templateNavBar: '#F5F7FA',
    templateDropdown: '#DDE1E6',
    templateFontSizeFunction: '#FFFFFF',
    templateFontSizeBackground: '#DDE1E6',
    templateModified: '#3498DB',
    templateModifiedHover: '#2980B9',
    templateNotModified: '#DDE1E6',

    templateToolEnabled: '#3498DB',
    templateToolDisabled: '#DDE1E6',
    templateToolEnabledHover: '#2980B9',
    templateToolDisabledHover: '#EBF0F5',

    attributeRow: '#2C3E50',
    attributeRowHover: '#576574',
    selectedAttributeRow: '#2ECC71',

    formRow: '#FFFFFF',
    formRowHover: '#F5F7FA', 
    selectedFormRow: '#EBF0F5',
    formRowTitle: '#3498DB',
    formRowArrow: '#576574',
    formRowMovingArrow: '#3498DB',
    formRowMovingArrowHover: 'rgba(52, 152, 219, 0.2)',
    formRowRemoveField: '#E74C3C',
    formRowRemoveFieldHover: '#c0392b',

    autoCompleteQuitHover: 'rgba(127, 140, 141, 0.5)',
    autoCompleteAccountBackground: 'rgba(52, 152, 219, 0.5)',
    autoCompletePatientName: '#3498DB',
    autoCompleteSubmitButton: '#2980B9',
    autoCompleteSubmitButtonHover: '#3498DB',

    documentOptionsColor: '#3498DB',
    documentOptionsHover: 'rgba(52, 152, 219, 0.1)',

    documentOptionsKeepEditing: '#3498DB',
    documentOptionsKeepEditingHover: '#2980B9',

    templateSelectPatientInfo: '#2C3E50',
    templatePatientsListSearch: '#576574',
    templatePatientsListSearchBackground: '#DDE1E6',  

    templatePatientRow: '#2C3E50',
    templatePatientRowHover: '#576574',
    templatePatientRowIcon: '#3498DB',
    selectedPatientRow: '#2980B9',

    templateSidebar: '#FFFFFF',
    selectedSideBarItem: '#3498DB',
    templateSidebarItemHover: 'rgba(87, 101, 116, 0.2)',

    sidebarIconColor: '#2C3E50', 

    // Consultation 

    consultationQuit: 'rgba(231, 76, 60, 0.4)', 
    consultationQuitHover: 'rgba(231, 76, 60, 0.8)', 

    consultationNote: 'rgba(155, 89, 182, 0.2)',
    consultationNoteHover: 'rgba(155, 89, 182, 0.4)',

    templateBanner: 'rgba(52, 152, 219, 0.2)',
    templateBannerHover:  'rgba(52, 152, 219, 0.4)',

    cameraBanner: 'rgba(46, 204, 113, 0.2)',
    cameraBannerHover:  'rgba(46, 204, 113, 0.4)',

    attachFileIcon: '#F39C12',
    attachFile: 'rgba(243, 156, 18, 0.2)', 
    attachFileHover: 'rgba(243, 156, 18, 0.4)',

    importFile: 'rgba(46, 204, 113, 0.2)', 
    importFileHover: 'rgba(46, 204, 113, 0.4)',  

    navbarToolEnabled: '#3498DB',
    navbarToolEnabledHover: '#2980B9',

    navbarToolDisabled: '#DDE1E6',
    navbarToolDisabledHover: '#EBF0F5',

    consultationNavBarArrows: '#576574', 

    consultationNoteSideBar: '#FFFFFF',
    consultationNoteFieldHeader: '#3498DB',

    consultaitonNoteFieldQuit: '#E74C3C', 

    // Note Microphone 

    microphoneDisabled: '#95a5a6', 
    microphoneEnabled: '#E74C3C', 
    microphoneIcon: '#FFFFFF', 
    microphoneOption: '#3498DB', 
    microphoneOptionIcon: '#FFFFFF', 

    avatarBorder: 'rgba(52, 152, 219, 0.6)',
    avatar: 'rgba(52, 152, 219, 0.1)',

    micOptionsListBackground: '#FFFFFF',
    micOptionsListShadow: 'rgba(44, 62, 80, 0.1)',

    // Colors  (most of the fields above used one of them). 

    green: '#2ECC71', 
    orange: '#F39C12', 
    purple: '#9B59B6', 
    grey: '#95a5a6', 
    red: '#E74C3C', 

    lightBlue: '#3498DB',
    darkGreen: '#27AE60', 
    darkBlue: '#2980B9', 
    darkPurple: '#8E44AD', 

}; 

export default lightTheme;